import {
    SYNC_CTC_INFORMATION_OPEN_MODAL,
    SYNC_CTC_INFORMATION_REQUEST,
    SYNC_CTC_INFORMATION_RESULT,
} from 'Redux/actionTypes';

export const syncCTCInformationOpenModal = (open) => ({
    type: SYNC_CTC_INFORMATION_OPEN_MODAL,
    payload: { open }
})

export const syncCTCInformationRequest = () => ({
    type: SYNC_CTC_INFORMATION_REQUEST
})

export const syncCTCInformationResult = (data) => ({
    type: SYNC_CTC_INFORMATION_RESULT,
    payload: { data }
})

